<!-- AI Generated Template -->
<page-header
        icon="fas fa-file-image"
        [header]="'Images' | translate"
        [subHeader]="subheaderTranslation">
</page-header>
<mon-tabs
        [showSearch]="true"
        [options]="tabs"
        (onStatus)="onStatus($event)"
        [(status)]="activeTab"
        (onSearch)="onSearch($event)"
        [search]="search"
        [minSearchLength]="1">
    <csv-export-button category="inventory_images"></csv-export-button>
</mon-tabs>
<div class="card panel-monsido-card">
    <div class="card-body">
        <div class="mx-4">
            <table-container [collection]="links"
                             (onPageChange)="onPageChange($event)"
                             (onPerPageChange)="onPageSizeChange($event)"
                             [progress]="promise">
                <table class="table table-hover table-fixed">
                    <thead>
                    <tr>
                        <th class="col-sm-34 col-md-40 col-lg-42" translate>URL</th>
                        <th class="col-sm-7 col-md-4 col-lg-3 text-right"></th>
                        <th class="col-sm-7 col-md-4 col-lg-3 text-right"></th>
                    </tr>
                    </thead>
                    <tbody>
                    <tr *ngFor="let link of links">
                        <td class="text-v-middle text-ellipsis">
                            <a [href]="link.url" target="_blank" aria-describedby="linkOpensInNewTab">
                                {{ link.url }}
                            </a>
                        </td>
                        <td class="text-v-middle text-right" [attr.aria-label]="'Metadata and pages' | translate">
                            <button class="btn btn-border-radius btn-secondary mr-1"
                            *ngIf="hasAccessToMetaDataOverlay"
                            triggers="focus hover"
                            [ngbTooltip]="'Open metadata view' | translate"
                            (click)="openMetadataModal(link)"
                            monEventTrigger="actionTrigger"
                            [monEventParams]="{action: 'open-metadata-view'}">
                                <span class="fas fa-info-circle" aria-hidden="true"></span>
                            </button>
                        </td>
                        <td class="text-v-middle text-right" [attr.aria-label]="'Metadata and pages' | translate">
                            <pages-button (callback)="openDialog(link)" [ngModel]="link.html_pages_count" [monAriaLabel]="'Show pages with this image' | translate">
                            </pages-button>
                        </td>
                    </tr>
                    </tbody>
                </table>
            </table-container>
        </div>
    </div>
</div>
